import { cn } from '@/lib/utils'
import React from 'react'

interface IProps {
    className?: string
    children?: React.ReactNode
}

/**
 * A linha é um componente de módulo, e não uma função declarada dentro do
 * `HorizontalDivider`: declarada dentro, cada render cria um tipo de
 * componente novo e o React troca o `<div>` da linha por outro. Dentro de um
 * diálogo essa remoção é fatal — o `FocusScope` do Radix observa o DOM e, ao
 * ver nós removidos enquanto o foco está de passagem pelo `body` (o instante
 * entre o `blur` e o `focus` do Tab), presume que o campo focado saiu da tela
 * e joga o foco no próprio diálogo. Resultado: Tab tirava o foco do
 * formulário.
 */
function Line({ temRotulo }: { temRotulo: boolean }) {
    return (
        <div
            className={cn('flex-1 h-px bg-border w-full', {
                'w-auto': temRotulo,
            })}
        />
    )
}

export default function HorizontalDivider({ className, children }: IProps) {
    const temRotulo = React.Children.toArray(children).length > 0

    if (temRotulo)
        return (
            <div className={cn('w-full flex items-center gap-x-2', className)}>
                <Line temRotulo />
                <span className="w-fit select-none inline-flex items-center gap-1">
                    {children}
                </span>
                <Line temRotulo />
            </div>
        )
    return (
        <div className={cn('flex w-full h-[1.5rem] items-center', className)}>
            <Line temRotulo={false} />
        </div>
    )
}
